import classNames from '@utils/classnames';
import React, { useEffect, useRef } from 'react';

export interface ICheckboxProps {
  id?: string;
  isChecked: boolean;
  /** Partially-checked state (dash), e.g. a "select all" box with some items selected. */
  isIndeterminate?: boolean;
  onChange: (isChecked: boolean) => void;
  isDisabled?: boolean;
  isInvalid?: boolean;
  className?: string;
}

/** 16px checkbox — brand fill with a white check when on (styles in `globals.css` → `.checkbox`). */
export const Checkbox: React.FC<ICheckboxProps> = (props) => {
  const { id, onChange, isChecked, isIndeterminate = false, isDisabled, isInvalid, className } = props;
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  return (
    <input
      ref={ref}
      id={id}
      type="checkbox"
      aria-invalid={isInvalid || undefined}
      className={classNames('checkbox', className)}
      onChange={(evt) => onChange(evt.target.checked)}
      checked={isChecked}
      disabled={isDisabled}
    ></input>
  );
};
